import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { BlurView } from "expo-blur";

interface CustomNotificationToastProps {
  title: string;
  body: string;
  onPress?: () => void;
}

export const CustomNotificationToast: React.FC<
  CustomNotificationToastProps
> = ({ title, body, onPress }) => {
  const { width } = Dimensions.get("window");

  return (
    <TouchableOpacity
      style={[styles.container, { width: width - 32 }]}
      onPress={onPress}
      activeOpacity={0.9}
    >
      <BlurView intensity={20} tint="light" style={styles.blurContainer}>
        <LinearGradient
          colors={["rgba(255, 255, 255, 0.9)", "rgba(255, 255, 255, 0.7)"]}
          style={styles.gradient}
        >
          <View style={styles.iconContainer}>
            <View style={styles.icon}>
              <View style={styles.iconDot} />
            </View>
          </View>

          <View style={styles.contentContainer}>
            <Text style={styles.title} numberOfLines={1}>
              {title}
            </Text>
            <Text style={styles.body} numberOfLines={4}>
              {body}
            </Text>
          </View>

          <View style={styles.actionContainer}>
            <View style={styles.actionDots}>
              <View style={[styles.dot, styles.activeDot]} />
              <View style={styles.dot} />
              <View style={styles.dot} />
            </View>
          </View>
        </LinearGradient>
      </BlurView>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 16,
    borderRadius: 16,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
  },
  blurContainer: {
    flex: 1,
    borderRadius: 16,
    overflow: "hidden",
  },
  gradient: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    minHeight: 80,
  },
  iconContainer: {
    marginRight: 12,
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "rgba(55, 148, 73, 0.1)",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 2,
    borderColor: "rgba(55, 148, 73, 0.2)",
  },
  iconDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: "#369449",
  },
  contentContainer: {
    flex: 1,
    marginRight: 12,
  },
  title: {
    fontSize: 16,
    fontWeight: "600",
    color: "#1F2937",
    marginBottom: 4,
    lineHeight: 20,
  },
  body: {
    fontSize: 14,
    color: "#6B7280",
    lineHeight: 18,
  },
  actionContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  actionDots: {
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
  },
  dot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: "rgba(107, 114, 128, 0.3)",
  },
  activeDot: {
    backgroundColor: "#369449",
  },
});
